import { Component, OnInit } from '@angular/core';
import { TimeAgoPipe } from '../../../../utils/pipe/time-ago.pipe';
import { UtcToLocalPipe } from '../../../../utils/pipe/utc-to-local.pipe';
import { NewsService } from '../news.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { ThumbnailPipe } from '../../../../utils/pipe/thumbnail.pipe'; 

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.scss'],
  providers: [TimeAgoPipe, UtcToLocalPipe,ThumbnailPipe ]

})
export class NewsDetailsComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private NewsService: NewsService, private timeAgoPipe: TimeAgoPipe, private utcToLocalPipe: UtcToLocalPipe, private thumbnailPipe:ThumbnailPipe) { }

  private baseUrl = environment.apiUrl;
  id: string | null = null;

  news: any= {title:'', content:''};

  topNews: any;
  archives: any;
  categories: any;
  searchInput: string = '';

  goToNews(element: any) {
    this.router.navigate(['/news/view/', element.id]);
  }


  formatDate(dateString: string): string {
    const monthNames = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    const [month, year] = dateString.split('-');
    return `${monthNames[+month - 1]} - ${year}`;
  }

  loadData() {
    this.route.paramMap.subscribe(params => {
      this.NewsService.getNewsAndCountById(params.get('id')).subscribe((response) => {
        response['imageUrl'] = this.baseUrl+response['imageUrl'];

        this.news = response;
      });
    });
  }

  ngOnInit(): void {
    this.loadData();
    this.NewsService.getTopNews().subscribe((response) => {
      response.forEach((item) => {
        item['image'] = this.thumbnailPipe.transform(this.baseUrl+item['image']);

      });
      this.topNews = response;
    });


    this.NewsService.getArchives().subscribe((response) => {
      response.forEach(element => {
        element['dateParsed'] = this.formatDate(element.date)
      });
      this.archives = response;
    });

    this.NewsService.getCategories().subscribe((response) => {
      this.categories = response;
    });
  }


  searchByTitleOrContent() {
    this.router.navigate(['/news'], { state: { filter: 'search', value: this.searchInput } });
  }


  searchByArchive(item: any) {
    this.router.navigate(['/news'], { state: { filter: 'archive', value: item } });
  }

  searchByCategory(item: any) {
    this.router.navigate(['/news'], { state: { filter: 'category', value: item } });
  }
}
